angular.module('jv.EditableButtons.Constants', [])
	.constant('EDITABLEBUTTONSTEMPLATEID', 'editableButtons')
	.value('editableButtonsTemplate', '<div><button class="grayButton" ng-click="edit()" ng-show="!editMode">{EDIT}</button><button class="grayButton" ng-click="cancel()" ng-show="editMode">{CANCEL}</button><button class="blueButton" ng-click="save()" ng-show="editMode">{SAVE}</button></div>')
	.run(['$templateCache', 'editableButtonsTemplate', 'EDITABLEBUTTONSTEMPLATEID', function($templateCache, editableButtonsTemplate, EDITABLEBUTTONSTEMPLATEID) {
		if(angular.isUndefined($templateCache.get(EDITABLEBUTTONSTEMPLATEID))) {
			$templateCache.put(EDITABLEBUTTONSTEMPLATEID, editableButtonsTemplate);
		}
	}]);

angular.module('jv.EditableButtons.Dir', ['jv.EditableButtons.Constants'])

	.directive("editableButtons", ['EDITABLEBUTTONSTEMPLATEID', '$templateCache', function(EDITABLEBUTTONSTEMPLATEID, tc) {
		return {
			restrict: 'E',
			template: tc.get(EDITABLEBUTTONSTEMPLATEID),
			replace:true,
			scope: {
				save: '&onSave',
				edit: '&onEdit',
				cancel: '&onCancel',
				editMode: '='
			},
			link: function(scope, el, attr) {
				function wrapCallback(callback) {
					return function() {
						scope.editMode = !scope.editMode;
						callback();
					};
				}

				var _edit = scope.edit,
					_save = scope.save,
					_cancel = scope.cancel;

				scope.edit = wrapCallback(_edit);
				scope.cancel = wrapCallback(_cancel);
				scope.save = wrapCallback(_save);
				scope.editMode = false;
			}
		};
	}]);